<template>
<div>
    <Navbar />
    <Breadcrumbs></Breadcrumbs>
    <EmployeesAssignmentAndTrip/>
    <Footer />
</div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import EmployeesAssignmentAndTrip from '@/components/employees/EmployeesAssignmentAndTrip.vue'
import Footer from '@/components/Footer.vue';

export default {
    components: {
        Navbar,
        EmployeesAssignmentAndTrip,
        Footer
    }
}
</script>

<style scoped>

</style>